// @flow
import { handlePaginatedMapRequest } from '../phasedActionHelpers';

import type { LoadEnsemblesAction } from '../../actions/ensemble';

export type State = {
  +[key: string]: {|
    +loading: boolean,
    +loaded: boolean,
    +loadedCursors: { [key: string]: boolean },
    +entities: Array<number>,
    +meta: {
      +count: number,
      +cursor: { +next: ?string, +prev: ?string },
    },
  |},
};

const initialState = {};

export default function ensembles(state: State = initialState, action: LoadEnsemblesAction) {
  if (action.type === 'FETCH_ENSEMBLES' && action.cacheId) {
    return handlePaginatedMapRequest(state, action, action.cacheId);
  }

  return state;
}
